module.exports = __webpack_public_path__ + "img/Checkinhabilitado.7a2f0b05.png";